import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, maxLenght: number): any {
    if (value && value.length > maxLenght) {
      return value.substr(0, maxLenght) + '...';
    }

    return value;
  }

}
